<template>
  <div>
    <history-filter-link :filterLayout="filterLayout" ></history-filter-link>
    <history-list-link :listLayout="listLayout" :historyData="List"></history-list-link>
    <pagination-link :paginationLayout="paginationLayout" :type="historyType"></pagination-link>
  </div>
</template>

<script>
import HistoryFilterLink from "@/components/history/HistoryFilterLink";
import HistoryListLink from "@/components/history/HistoryListLink";
import PaginationLink from "@/components/history/PaginationLink";
import historyUtil from "@/components/history/historyUtil";

export default {
  name: "HistoryListComponent",
  mixins: [historyUtil],
  components: {
    HistoryFilterLink,
    HistoryListLink,
    PaginationLink,
  },
  inject: [],
  provide() {
    return{

    }
  },
  props: {
    historyType: {default: ''}
  },
  data() {
    return{
      getFunc: '',
      listLayout: '',
      filterLayout: '',
      paginationLayout: '',
    }
  },
  beforeRouterEnter() {},
  created() {
    this.initConfig();
  },
  mounted() {

  },
  beforeDestroy() {
  },
  destroyed() {},
  computed: {
  },
  methods:{
    initConfig(){
      let historyConfig = this.returnHistoryConfig(this.historyType);
      this.listLayout = historyConfig.listLayout;
      this.filterLayout = historyConfig.filterLayout;
      this.paginationLayout = historyConfig.paginationLayout;
    },
  },
  watch: {

  },
}
</script>

<style scoped>

</style>